// src/pages/Payments/components/IdentificationForm.tsx
import React from "react";
import CardSection from "../../../components/ui/CardSection";
import PaymentsInput from "./PaymentsInput";
import { ISaleForm } from "../../../classes/interfaces";

interface IdentificationFormProps {
  formValues: ISaleForm;
  setFormValues: React.Dispatch<React.SetStateAction<ISaleForm>>;
}

export default function IdentificationForm({ formValues, setFormValues }: IdentificationFormProps) {
  return (
    <CardSection icon="user" title="Identificação">
      <PaymentsInput
        label="Nome"
        name="name"
        value={formValues.name}
        onChange={setFormValues}
        maxLenght={100}
      />

      <PaymentsInput
        label="Telefone"
        name="phone"
        value={formValues.phone}
        onChange={setFormValues}
        maxLenght={20}
        numberOnly={true}
      />

      <PaymentsInput
        label="CPF ou CNPJ para documento fiscal (opcional)"
        name="taxPayerIdentificationNumber"
        value={formValues.taxPayerIdentificationNumber}
        onChange={setFormValues}
        maxLenght={14}
        numberOnly={true}
      />
    </CardSection>
  );
}
